<template>
  <div class="vx-card p-3 flex justify-center">
    <div
      v-if="isValidScore"
      class="text-center self-center"
    >
      <div v-if="title">
        {{ title }}
      </div>
      <div class="text-3xl break-all">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreCard',
  props: {
    title: {
      type: String,
      default: null
    },
    score: {
      type: Number,
      default: null
    },
    percent: {
      type: Boolean,
      default: false
    },
    currency: {
      type: Boolean,
      default: false
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    }
  },
  computed: {
    isValidScore () {
      return typeof this.score === 'number'
    },
    value () {
      let score = this.score
      if (this.percent) {
        score = this.score * 100
      }
      const base = 10 ** this.precision
      const v = Math.round(score * base) / base
      if (this.currency) {
        return `\xA5${v.toLocaleString()}`
      }
      if (this.percent) {
        return `${(v).toLocaleString()}%`
      }
      return v.toLocaleString()
    }
  }
}
</script>

<style scoped>

</style>
